export default {"src":"/_next/static/media/dogEmergency_24.9f6c59c1.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};